(()=>{
 'use strict';
 const ID='10786059780443',shell=document.querySelector('[data-mf-tassen-designer-shell]');
 if(!shell||shell.dataset.mfKarabinerCartBridge==='2')return;
 shell.dataset.mfKarabinerCartBridge='2';
 let busy=false;
 const host=shell.querySelector('[data-mf-tassen-designer-host]');
 const norm=s=>String(s||'').trim().replace(/\s+/g,' ').toUpperCase();
 const status=(msg,isError=false)=>{
   const sr=host?.shadowRoot,box=sr?.querySelector('[data-mf-karabiner-cart-status]')||document.createElement('p');
   if(!sr)return;
   box.dataset.mfKarabinerCartStatus='1';
   box.setAttribute('role','status');
   box.style.cssText='font-size:12px;font-weight:800;padding:8px 10px;border-radius:7px;margin:10px 0;color:'+(isError?'#9f1d10':'#195c30')+';background:'+(isError?'#fff0ed':'#e8f8e8')+';';
   box.textContent=msg;
   const anchor=sr.querySelector('.action-stack')||sr.querySelector('.controls-card');
   if(anchor)anchor.before(box);
 };
 const makeFile=(canvas,name)=>new Promise((resolve,reject)=>{
   if(!canvas||!canvas.width||!canvas.height)return reject(new Error('Vorschau/Druckbild noch nicht geladen.'));
   try{canvas.toBlob(b=>b?.size?resolve(new File([b],name,{type:'image/png'})):reject(new Error('Bilddatei leer.')),'image/png')}catch(e){reject(e)}
 });
 const imageFromData=async()=>{
   const sr=host?.shadowRoot;
   const input=sr?.querySelector('.upload-button input[type=file]')||sr?.querySelector('.printable-area input[type=file]');
   const original=input?.files?.[0];
   if(original)return original;
   const uri=sr?.querySelector('.image-layer img')?.src||'';
   if(!uri.startsWith('data:image/'))return null;
   try{
     const comma=uri.indexOf(','),mime=uri.slice(5,comma).split(';')[0];
     const base64=uri.slice(comma+1);
     const binary=atob(base64);const bytes=new Uint8Array(binary.length);
     for(let i=0;i<binary.length;i++)bytes[i]=binary.charCodeAt(i);
     const ext=mime==='image/jpeg'?'jpg':mime==='image/webp'?'webp':'png';
     const name=sr?.querySelector('.file-name')?.textContent?.trim()||'Kundenfoto.'+ext;
     return new File([bytes],name,{type:mime});
   }catch(e){console.warn('[Karabiner Designer] Ursprungsbild nicht lesbar',e);return null}
 };
 function elements(){
   const sr=host?.shadowRoot;
   if(!sr)throw Error('Designer noch nicht geöffnet.');
   return sr;
 }
 function select(){
   const variant=String(host?.dataset.mfChosenVariant||shell.dataset.mfVariantId||'');
   const known=JSON.parse(host?.dataset.mfVariants||'[]');
   const v=known.find(v=>String(v.id)===variant);
   if(!v||!v.available)throw Error('Bitte eine verfügbare Variante auswählen.');
   return v;
 }
 function selectedQuantity(){
   const value=Number(host?.dataset.mfQuantity||0);
   if(host?.dataset.mfQuantitySelected!=='1'||!Number.isInteger(value)||value<1||value>99)throw Error('Bitte eine Stückzahl von 1 bis 99 auswählen.');
   return value;
 }
 async function submit(plain=false,button=null){
   if(busy)return;
   busy=true;
   const before=button?.textContent||'PERSONALISIERT IN DEN WARENKORB';
   if(button){button.disabled=true;button.textContent='GESTALTUNG WIRD ÜBERTRAGEN …'}
   try{
     const v=select(),qty=selectedQuantity(),sr=elements();
     const image=await imageFromData(),text=sr.querySelector('#mug-text')?.value?.trim()||'';
     if(!plain&&!image&&!text)throw Error('Bitte erst ein Foto oder Wunschtext einfügen.');
     const id=crypto.randomUUID?.()||String(Date.now());
     const fd=new FormData();
     fd.append('id',String(v.id));fd.append('quantity',String(qty));
     fd.append('properties[Karabinerfarbe]',host.dataset.mfKarabinerColor||v.option2);
     fd.append('properties[Druckposition]',host.dataset.mfDruckposition||v.option1);
     if(!plain){
       const texture=window.__MF_KARABINER_PRINT_TEXTURE__;
       if(!texture)throw Error('Die Druckvorschau ist noch nicht bereit.');
       const print=await makeFile(texture,'MF-'+id+'-Druckmotiv.png');
       const previewCanvas=sr.querySelector('.mug-3d-preview canvas');
       const preview=await makeFile(previewCanvas,'MF-'+id+'-Tassenvorschau.png');
       const editor=sr.querySelector('.printable-area');
       const picture=editor?.querySelector('.image-layer'),label=editor?.querySelector('.text-layer');
       const metadata={
         version:'mf-karabiner-normal-tassen-v2',id,variantId:v.id,variantTitle:v.title,
         carabinerColor:host.dataset.mfKarabinerColor||v.option2,
         position:host.dataset.mfDruckposition||v.option1,
         note:'Druckbereich im Designer schematisch; Produktionsmaße vor Fertigung überprüfen.',
         image:{name:image?.name||null,left:picture?.style.left||null,top:picture?.style.top||null,
           width:picture?.style.width||null,height:picture?.style.height||null,
           transform:picture?.style.transform||null},
         text:{value:text,left:label?.style.left||null,top:label?.style.top||null,
           font:label?.style.fontFamily||null,color:label?.style.color||null}
       };
       const details=new File([JSON.stringify(metadata,null,2)],'MF-'+id+'-Designdaten.json',{type:'application/json'});
       fd.append('properties[Personalisierung]','Tassen-Designer');
       fd.append('properties[_MF Designer]','karabiner-normal-v2');
       fd.append('properties[_MF Design-ID]',id);
       fd.append('properties[_MF Druckdatei]',print,print.name);
       fd.append('properties[_MF Vorschau]',preview,preview.name);
       fd.append('properties[_MF Designer-Screenshot]',preview,preview.name);
       fd.append('properties[_MF Screenshot-Status]','ja');
       fd.append('properties[_MF Design-Daten]',details,details.name);
       if(image)fd.append('properties[_MF Kundenfoto]',image,image.name);
       if(text)fd.append('properties[Wunschtext]',text.slice(0,200));
     }else{
       fd.append('properties[Personalisierung]','Ohne Personalisierung');
     }
     status('Druckmotiv, Vorschau und Bestellung werden übermittelt.');
     const base=window.Shopify?.routes?.root||'/';
     const response=await fetch(base+'cart/add.js',{method:'POST',headers:{Accept:'application/json'},body:fd});
     const data=await response.json().catch(()=>({}));
     if(!response.ok)throw Error(data.description||data.message||'Shopify-Fehler '+response.status);
     status('Erfolgreich zum Warenkorb hinzugefügt.');
     window.location.assign(base+'cart');
   }catch(e){
     console.error('[MF Karabiner Warenkorb]',e);
     status(String(e.message||e),true);
     if(button){button.disabled=false;button.textContent=before}
     busy=false;
   }
 }
 document.addEventListener('click',e=>{
   const dialog=shell.querySelector('.mf-designer-dialog');
   if(!dialog?.open)return;
   const path=e.composedPath?.()||[];
   const primary=path.find(el=>el?.nodeType===1&&el.matches?.('.primary-action,.secondary-action'));
   if(!primary)return;
   const text=norm(primary.textContent);
   if(!text.startsWith('PERSONALISIERT IN DEN WARENKORB')&&!text.startsWith('OHNE PERSONALISIERUNG KAUFEN'))return;
   e.preventDefault();e.stopPropagation();e.stopImmediatePropagation();
   submit(text.startsWith('OHNE PERSONALISIERUNG KAUFEN'),primary);
 },true);
})();
